import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Space,
  Divider,
  message
} from 'antd';
import {
  UserOutlined,
  LockOutlined,
  LoginOutlined,
  SafetyOutlined,
  ArrowLeftOutlined,
  TruckOutlined
} from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { ApiServices } from '../../services/apiServices';
import { ApiConfig } from '../../services/ApiConfigs';
import { useDispatch } from 'react-redux';
import { setUserData } from '../../redux/actions/DataActions';
import store from '../../redux/store';
import { errorMsg, successMsg } from '../../utils/ShowMessage';
import { routes } from "../../utils/routes.config";
import { handleCheckAuth } from '../../utils/handleAuth';
import './login.css';

const { Title, Text } = Typography;

const Login = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const authUser = handleCheckAuth();
    if (authUser) {
      const userData = store.getState().UserData.userData;
      if (userData?.role === "superAdmin") {
        navigate(routes.SUPER_DASHBOARD);
      } else if (userData?.role === "user" && userData?.hasActivePlan === false) {
        navigate(routes.SELECT_PLAN);
      } else {
        navigate(routes.DASHBOARD);
      }
    }
  }, [navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await ApiServices('post', ApiConfig.LOGIN, values);
      console.log(res.role, "login response..");

      if (res.role === "admin" || res.role === "user" || res.role === "superAdmin") {
        dispatch(setUserData(res));
        successMsg("Login successfully.");

        if (res.role === "superAdmin") {
          navigate(routes.SUPER_DASHBOARD);
        } else if (res.role === "user") {
          if (res.hasActivePlan === false) {
            navigate(routes.SELECT_PLAN);
          } else {
            navigate(routes.DASHBOARD);
          }
        } else if (res.role === "admin") {
          navigate(routes.DASHBOARD);
        }
      } else {
        errorMsg("User not authorized. Please contact admin.");
      }
    } catch (error) {
      console.log(error);
      errorMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className="login-page">
      {/* Background with animated elements */}
      <div className="login-background">
        <div className="login-background-pattern"></div>
        <div className="login-background-gradient"></div>
      </div>

      {/* Back to Home Link */}
      <Link to={routes.HOME} className="back-to-home">
        <ArrowLeftOutlined /> Back to Home
      </Link>

      <div className="login-container">
        <Card className="login-card">
          {/* Logo and Title Section */}
          <div className="login-header">
            <div className="login-logo-wrapper">
              <TruckOutlined className="login-logo-icon" />
            </div>
            <Title level={2} className="login-title">
              Welcome Back
            </Title>
            <Text className="login-subtitle">
              Sign in to access your delivery management dashboard
            </Text>
          </div>

          <Divider className="login-divider" />

          {/* Login Form */}
          <Form
            form={form}
            name="login"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            size="large"
            initialValues={{
              email: "",
              password: ""
            }}
          >
            <Form.Item
              name="email"
              label={<Text strong>Email Address</Text>}
              rules={[
                {
                  required: true,
                  message: 'Please input your email!'
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email address!'
                }
              ]}
            >
              <Input
                prefix={<UserOutlined style={{ color: '#1890ff' }} />}
                placeholder="Enter your email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label={<Text strong>Password</Text>}
              rules={[
                {
                  required: true,
                  message: 'Please input your password!'
                },
                {
                  min: 6,
                  message: 'Password must be at least 6 characters!'
                }
              ]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#1890ff' }} />}
                placeholder="Enter your password"
              />
            </Form.Item>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: -6, marginBottom: 10 }}>
            <Link to={routes.FORGOT_PASSWORD} style={{ fontSize: 13 }}>
              Forgot password?
            </Link>
          </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                size="large"
                icon={<LoginOutlined />}
                className="login-submit-button"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </Form.Item>
          </Form>

          {/* Footer */}
          <div className="login-footer">
            <Space>
              <SafetyOutlined className="login-security-icon" />
              <Text className="login-security-text">
                Secure login with encrypted connection
              </Text>
            </Space>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login;

